<template>
    <div class="CensusApproval">
        <div class="container-fluid">
            <div class="row">
                <div class="col paper" style="text-align:end;">
                    <Logout />
                    <h3 class="center-text"><font-awesome-icon :icon="['fa', 'thumbs-o-up']" /> Olive Crest Census Approval</h3>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-12 col-md-8">
                    <div class="col-md paper">
                        {{ApprovalMessage}}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="whitetext">NOTICE: This system contains privileged and/or confidential information for the sole use of the intended recipient. Any review, use, distribution or disclosure by others is strictly prohibited. If you are not the intended recipient and/or not an authorized user of this system, please log out immediately and delete all copies of information obtained from this system.</p>
                    <p class="whitetext">&copy; 2025 - Olive Crest</p>
                </div>
            </div>
        </div>

        
    </div>
</template>

<script>
    import { EventBus } from '../../services/event-bus.js';
    import Logout from '../Core/UI/Logout.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faThumbsUp } from '@fortawesome/free-solid-svg-icons';
    library.add(faThumbsUp);

    export default {
        created() {

        },
        beforeDestroy() {
            
        },
        props: [],
        data: function () {
            return {
                ApprovalMessage: "CHECKING...",
            };
        },
        methods: {
            SubmitReview() {
                this.$MasterAPI.ExecuteRequest("PATCH", "Core/CensusApprovals/RecordCensusApprovalReview", { Id: this.$route.query.ApprovalID, ReviewerResponse: this.$route.query.ReviewerResponse }, this.SubmitReviewSuccess, this.SubmitReviewError, true);
            },
            SubmitReviewSuccess(response) {
                this.ApprovalMessage = response.data.data;
            },
            SubmitReviewError(e) {
                this.ApprovalMessage = "ERROR: There was a problem recording your response.  Please contact portal support for assistance.";
            }
        },
        components: {
            Logout
        },
        computed: {

        },
        mounted() {
            this.SubmitReview();
        }
    }
</script>

<style>
    body {
        background-color: #94A545;
    }
</style>